var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShapeDesktop2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 138 160",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.81507 118.644C16.688 195.22 72.4462 147.001 98.5914 113.319C204.905 -10.5013 57.3226 -19.194 58.5805 24.3167C59.8381 67.8276 -14.5257 22.9229 2.81507 118.644Z",
  fill: "current"
})));
export default SvgShapeDesktop2;